const formatBalance = value => {
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    if (Number.isInteger(num)) return num;
    return num.toFixed(2);
};

export default formatBalance;